import SubcategoryDescriptionFull from './SubcategoryDescriptionFull'

export default SubcategoryDescriptionFull
// eslint-disable-next-line import/export
export * from './SubcategoryDescriptionFull'
